const texture = [
    {
        name: "clayey",
        clay: {
            low_threshold: 40,
            high_threshold: 100, 
        },
        lime: {
            low_threshold: 0,
            high_threshold: 40,
        },
        sand: {
            low_threshold: 0,
            high_threshold: 45,
        },
        type: "fine",
    },
    {    
        name: "claySandy",
        clay: {
            low_threshold: 35,
            high_threshold: 55, 
        },
        lime: {
            low_threshold: 0,
            high_threshold: 20,
        },
        sand: {
            low_threshold: 45,
            high_threshold: 65,
        },
        type: "fine",
    },
    {
        name: "claySilty",
        clay: {
            low_threshold: 40,
            high_threshold: 60, 
        },
        lime: {
            low_threshold: 40,
            high_threshold: 60,
        },
        sand: {
            low_threshold: 0,
            high_threshold: 20,
        },
        type: "fine",
    },
    {
        name: "claySiltyLoam",
        clay: {
            low_threshold: 27,
            high_threshold: 40, 
        },
        lime: {
            low_threshold: 40,
            high_threshold: 72,
        },
        sand: {
            low_threshold: 0,
            high_threshold: 60,
        },
        type: "average",
    },
    {
        name: "clayerLoam",
        clay: {
            low_threshold: 27,
            high_threshold: 40, 
        },
        lime: {
            low_threshold: 15,
            high_threshold: 52,
        },
        sand: {
            low_threshold: 20,
            high_threshold: 45,
        },
        type: "average",
    },
    {
        name: "sandyClayLoam",
        clay: {
            low_threshold: 20,
            high_threshold: 35, 
        },
        lime: {
            low_threshold: 0,
            high_threshold: 27,
        },
        sand: {
            low_threshold: 45,
            high_threshold: 80,
        },
        type: "average",
    },
    {
        name: "loamy",
        clay: {
            low_threshold: 7,
            high_threshold: 27, 
        },
        lime: {
            low_threshold: 27,
            high_threshold: 50,
        },
        sand: {
            low_threshold: 22,
            high_threshold: 52,
        },
        type: "average",
    },
    {
        name: "siltyLoam",
        clay: {
            low_threshold: 0,
            high_threshold: 27, 
        },
        lime: {
            low_threshold: 50,
            high_threshold: 87,
        },
        sand: {
            low_threshold: 0,
            high_threshold: 50,
        },
        type: "average",
    },
    {
        name: "silty",
        clay: {
            low_threshold: 0,
            high_threshold: 12, 
        },
        lime: {
            low_threshold: 88,
            high_threshold: 100,
        },
        sand: {
            low_threshold: 0,
            high_threshold: 20,
        },
        type: "thick",
    },
    {
        name: "sandyLoam1",
        clay: {
            low_threshold: 0,
            high_threshold: 7, 
        },
        lime: {
            low_threshold: 42,
            high_threshold: 50,
        },
        sand: {
            low_threshold: 47,
            high_threshold: 52,
        },
        type: "thick",
    },
    {
        name: "sandyLoam2",
        clay: {
            low_threshold: 7,
            high_threshold: 20, 
        },
        lime: {
            low_threshold: 10,
            high_threshold: 42,
        },
        sand: {
            low_threshold: 52,
            high_threshold: 70,
        },
        type: "thick",
    },
    {
        name: "loamySandy",
        clay: {
            low_threshold: 0,
            high_threshold: 30, 
        },
        lime: {
            low_threshold: 0,
            high_threshold: 30,
        },
        sand: {
            low_threshold: 70,
            high_threshold: 90,
        },
        type: "thick",
    },
    {
        name: "sandy",
        clay: {
            low_threshold: 0,
            high_threshold: 10, 
        },
        lime: {
            low_threshold: 0,
            high_threshold: 10,
        },
        sand: {
            low_threshold: 90,
            high_threshold: 100,
        },
        type: "thick",
    }
]

export default texture;